import { render } from "./UiElementverzweigung.pug?vue&type=template&id=f8a74fd2&lang=pug"
import script from "./UiElementverzweigung.js?vue&type=script&lang=js"
export * from "./UiElementverzweigung.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__